import React from 'react';
import {
  Popover, PopoverContent, PopoverTrigger,
} from '@/components/ui/popover';
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from '@/components/ui/command';
import { Button } from '@/components/ui/button';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';

export function PgcAccountPicker({ accounts, value, onChange, testId }) {
  const [open, setOpen] = React.useState(false);
  const selected = accounts.find(a => a.codigo === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" className="w-full justify-between" data-testid={testId}>
          {selected ? <span className="font-mono mr-2">{selected.codigo}</span> : <span className="text-[hsl(var(--muted-foreground))]">Selecciona cuenta...</span>}
          {selected && <span className="truncate flex-1 text-left">{selected.nombre}</span>}
          <ChevronsUpDown className="h-4 w-4 opacity-50 ml-auto shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[420px]" align="start">
        <Command>
          <CommandInput placeholder="Buscar cuenta PGC..." data-testid={`${testId}-search-input`} />
          <CommandList>
            <CommandEmpty>Sin resultados</CommandEmpty>
            {[1,2,3,4,5,6,7].map(g => {
              const grpAccs = accounts.filter(a => a.grupo === g);
              if (grpAccs.length === 0) return null;
              return (
                <CommandGroup key={g} heading={`Grupo ${g}`}>
                  {grpAccs.map(a => (
                    <CommandItem
                      key={a.codigo}
                      value={`${a.codigo} ${a.nombre}`}
                      onSelect={() => { onChange(a.codigo); setOpen(false); }}
                      data-testid={`${testId}-option-${a.codigo}`}
                    >
                      <Check className={cn('mr-2 h-3.5 w-3.5', value === a.codigo ? 'opacity-100' : 'opacity-0')} />
                      <span className="font-mono mr-2 text-xs">{a.codigo}</span>
                      <span className="truncate">{a.nombre}</span>
                    </CommandItem>
                  ))}
                </CommandGroup>
              );
            })}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
